import { render } from "./CurrencyInputLabel.vue?vue&type=template&id=bb547b96&scoped=true"
import script from "./CurrencyInputLabel.vue?vue&type=script&lang=js"
export * from "./CurrencyInputLabel.vue?vue&type=script&lang=js"

import "./CurrencyInputLabel.vue?vue&type=style&index=0&id=bb547b96&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bb547b96"]])

export default __exports__